<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search"
               @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
            
            <el-col :md="6" :sm="12">
              <el-form-item label="日志标题:">
                <el-input v-model="table.where.title" placeholder="请输入日志标题" clearable/>
              </el-form-item>
            </el-col>
                                
            <el-col :md="6" :sm="12">
              <el-form-item label="操作类型:">
                <el-select v-model="table.where.type" placeholder="请选择操作类型" clearable class="ele-fluid">
                                      <el-option label="登录系统" value="1"/>
                                      <el-option label="注销系统" value="2"/>
                                      <el-option label="操作日志" value="3"/>
                                  </el-select>
              </el-form-item>
            </el-col>
                                            
            <el-col :md="6" :sm="12">
              <el-form-item label="有效标识:">
                <el-select v-model="table.where.mark" placeholder="请选择有效标识" clearable class="ele-fluid">
                                      <el-option label="正常" value="1"/>
                                      <el-option label="删除" value="0"/>
                                  </el-select>
              </el-form-item>
            </el-col>
                          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询
              </el-button>
              <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:actionlog202103:add')">添加
        </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:actionlog202103:dall')">批量删除
        </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
        <template slot-scope="{index}">
          <el-table-column type="selection" width="45" align="center" fixed="left"/>
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                  
          <el-table-column prop="username" label="操作人用户名" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="method" label="请求类型" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="module" label="模型" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="action" label="操作方法" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="url" label="操作页面" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="param" label="请求参数(JSON格式)" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="title" label="日志标题" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="type" label="操作类型" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="ip" label="IP地址" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="user_agent" label="User-Agent" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="content" label="内容" sortable="custom" show-overflow-tooltip min-width="120"/>
                  
          <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:actionlog202103:edit')">修改</el-link>
              <el-popconfirm title="确定要删除此系统行为日志吗？" @confirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:actionlog202103:delete')">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id?'修改系统行为日志':'修改系统行为日志'" :visible.sync="showEdit" width="450px"
               @closed="editForm={}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
                          
        <el-form-item label="操作人用户名：" prop="username">
            <el-input v-model="editForm.username" placeholder="请输入操作人用户名" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="请求类型：" prop="method">
            <el-input v-model="editForm.method" placeholder="请输入请求类型" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="模型：" prop="module">
            <el-input v-model="editForm.module" placeholder="请输入模型" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="操作方法：" prop="action">
            <el-input v-model="editForm.action" placeholder="请输入操作方法" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="操作页面：" prop="url">
            <el-input v-model="editForm.url" placeholder="请输入操作页面" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="请求参数(JSON格式)：" prop="param">
            <el-input-number v-model="editForm.param" controls-position="right" :min="0"
                              placeholder="请输入请求参数(JSON格式)" class="ele-fluid ele-text-left"/>
        </el-form-item>
                                                      
        <el-form-item label="日志标题：" prop="title">
            <el-input v-model="editForm.title" placeholder="请输入日志标题" clearable/>
        </el-form-item>
                                              
        <el-form-item label="操作类型：" prop="type">
          <el-select v-model="editForm.type" placeholder="请选择操作类型" class="ele-block" clearable>
            <el-option
                    v-for="item in []"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
                                                  
        <el-form-item label="IP地址：" prop="ip">
            <el-input v-model="editForm.ip" placeholder="请输入IP地址" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="User-Agent：" prop="user_agent">
            <el-input v-model="editForm.user_agent" placeholder="请输入User-Agent" clearable/>
        </el-form-item>
                                          
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SysActionLog202103",
  data() {
    return {
      table: {url: '/actionlog202103/index', where: {}},  // 表格配置
      choose: [],  // 表格选中数据
      showEdit: false,  // 是否显示表单弹窗
      editForm: {},  // 表单数据
      editRules: {  // 表单验证规则
                        
        username: [
          {required: true, message: '请输入操作人用户名', trigger: 'blur'}
        ],
                                    
        method: [
          {required: true, message: '请输入请求类型', trigger: 'blur'}
        ],
                                    
        module: [
          {required: true, message: '请输入模型', trigger: 'blur'}
        ],
                                    
        action: [
          {required: true, message: '请输入操作方法', trigger: 'blur'}
        ],
                                    
        url: [
          {required: true, message: '请输入操作页面', trigger: 'blur'}
        ],
                          
        param: [
          {required: true, message: '请输入请求参数(JSON格式)', trigger: 'blur'}
        ],
                                    
        title: [
          {required: true, message: '请输入日志标题', trigger: 'blur'}
        ],
                          
        type: [
          {required: true, message: '请选择操作类型', trigger: 'blur'}
        ],
                                    
        ip: [
          {required: true, message: '请输入IP地址', trigger: 'blur'}
        ],
                                    
        user_agent: [
          {required: true, message: '请输入User-Agent', trigger: 'blur'}
        ],
                                    
        content: [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],
              
      },
    }
  },
computed: {
    ...mapGetters(["permission"]),
},
  mounted() {
  },
  methods: {
    /**
     * 显示编辑
     */
    edit(row) {
      this.$http.get('/actionlog202103/info?id=' + row.id).then(res => {
        if (res.data.code === 0) {
          this.editForm = res.data.data;
          this.showEdit = true;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /**
     * 保存编辑
     */
    save() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true});
          this.$http.post('/actionlog202103/edit', this.editForm).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.showEdit = false;
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 刪除(批量刪除)
     */
    remove(row) {
      console.log(row)
      if (!row) {  // 批量删除
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.choose.map(d => d.id);
        this.$confirm('确定要删除选中的系统行为日志吗?', '提示', {type: 'warning'}).then(() => {
          const loading = this.$loading({lock: true});
          this.$http.post('/actionlog202103/delete', {id: ids}).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        }).catch(() => 0);
      } else {  // 单个删除
        const loading = this.$loading({lock: true});
        this.$http.post('/actionlog202103/delete', {id:row.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }
    },
                                                }
}
</script>

<style scoped>
.ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
  width: 100%;
}
</style>